<template>
  <div class="group-container">
    <div
      v-for="(item, index) in items"
      :class="['item', { active: item.active }]"
      :key="index"
      @click="onClick($event, item.value)"
    >
      <div class="outer-icon">
        <img
          v-for="(img, imgIndex) in item.imgs"
          :key="imgIndex"
          :src="img.src"
          :style="img.style"
        >
      </div>
      <i
        v-if="item.active"
        class="fas fa-dot-circle"/>
      <i
        v-else
        class="far fa-circle"/>
    </div>
  </div>
</template>

<script>
import { BILLING_PAYMENT_METHOD } from '../../helpers/enum'

const { CARD, LINE_PAY, PROMPTPAY } = BILLING_PAYMENT_METHOD

export default {
  props: {
    value: {
      type: String,
      default: CARD,
    },
  },

  data () {
    return {
      input: CARD,
    }
  },

  computed: {
    items () {
      return [
        {
          active: this.selected[PROMPTPAY],
          value: PROMPTPAY,
          imgs: [
            {
              src: require('@/assets/images/billing/promptpay.png'),
              style: 'width: 80px;',
            },
          ],
        },
        {
          active: this.selected[CARD],
          value: CARD,
          imgs: [
            {
              src: require('@/assets/images/billing/visa.png'),
              style: 'width: 40px;',
            },
            {
              src: require('@/assets/images/billing/master-card.png'),
              style: 'width: 31px; margin-left: 8px;',
            },
          ],
        },
        // {
        //   active: this.selected[LINE_PAY],
        //   value: LINE_PAY,
        //   imgs: [
        //     {
        //       src: require('@/assets/images/billing/line-pay.png'),
        //       style: 'width: 80px;',
        //     },
        //   ],
        // },
      ]
    },
    selected () {
      return {
        [CARD]: this.input === CARD,
        [LINE_PAY]: this.input === LINE_PAY,
        [PROMPTPAY]: this.input === PROMPTPAY,
      }
    },
  },

  watch: {
    input () {
      if (this.input) {
        this.$emit('onChange', this.input)
      }
    },
    value () {
      this.input = this.value
    },
  },

  mounted () {
    this.input = this.value
  },

  methods: {
    onClick (e, value) {
      this.input = value
    },
  },
}
</script>

<style scoped>
.group-container {
  display: flex;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}

.outer-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  padding: 0 10px;
  margin-bottom: 10px;
  border: 1px solid #E3E3E3;
  border-radius: 2px;
}

.fa-dot-circle, .fa-circle {
  color: #676767;
}

.fa-circle {
  font-size: 13px;
}

.item.active .outer-icon {
  background-color: #F4F4F4;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseRadioPaymentMethod.vue